import {
  ContactLink,
  ContactLinkValidate,
  ContactLinkValues,
  NameAndPlatform,
  NameAndPlatformValidate,
  NameAndPlatformValues,
} from '~/components/MediaPackSteps';
import { StepperFormStepType } from '~/components/StepperForm/StepperForm.types';
import { CreatorType, DefaultMediaPackType } from '~/types';

interface Props {
  creator: CreatorType;
  mediaPack: DefaultMediaPackType;
}

export const STEPS = ({ creator, mediaPack }: Props): StepperFormStepType[] => {
  const nameAndPlatformStep: StepperFormStepType<NameAndPlatformValues> = {
    component: NameAndPlatform,
    initialValues: {
      name: mediaPack.name || '',
      platforms: mediaPack.platforms || [],
    },
    onValidate: NameAndPlatformValidate,
    title: 'Name & Platforms',
  };
  const contactLinkStep: StepperFormStepType<ContactLinkValues> = {
    component: ContactLink,
    onValidate: ContactLinkValidate,
    initialValues: {
      email: mediaPack.email || creator?.manager?.email || creator?.email || '',
    },
    title: 'Contact link',
  };
  return [nameAndPlatformStep, contactLinkStep];
};
